import React, { useEffect, useRef, useState } from 'react';
import { Box, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, SwipeableViews } from '@mui/material';
import ItemBasicDetails from './ItemBasicDetails';
import ItemAttachment from './ItemAttachment';
import ItemDescription from './ItemDescription';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import Loader from '../Components/Loader';

import { uploadToServer } from '../../../library/upload';
import ConfirmCancel from '../../../components/modals/confirmCancel';
import moment from 'moment';
import ConfirmExit from '../../../components/modals/ConfirmExit';
import DraggableAction from '../../../components/Buttons/DraggableAction';
import { sellingPriceObj, purchasePriceObj } from './ItemListData';
import NewSellingPriceTable from './NewSellingPriceTable';
import { setNavigationBlocked, setModalBlocked } from '../../../redux/reducers/controllNavigation';
import useSaveShortcut from '../../../hooks/useSaveShortcut';
import '../Components/Invoice.css';
import { createItemTransaction, getItemmaster } from '../../../graphql';
import { VoucherSettingsApi } from '../../../redux/apis/newVoucherSettings.api';
import { createItemMasterWithDetails, createItemMasterWithDetailsAndImages } from '../../../graphql/postgress_graphql/customMutations';
import { dashboardApi } from '../../../redux/apis/dashboardApi';
import { useListPriceTypesQuery } from '../../../redux/apis/pricetype.api';
import { deepEqual, handleFreeze } from '../../../utils/common';
import API_ENDPOINTS from '../../../apiEndpoints';
import useControlledNavigation from '../../../hooks/useControlledNavigation';
import { CheckVoucherValid } from '../Components/CheckVoucherValid';


function AddNewItem({
  modalEvent,
  CategoryID,
  setItemID,
  closeModal,
  itemID,
  itemType,
  page,
  getItems,
  invDate,
  setAccNames,
  view,
  rowIndex,
  listItems,
}) {
  const [mainCategoryId, setMainCategoryId] = useState('');
  const [categoryId, setCategoryId] = useState();
  const dispatch = useDispatch();
  

  const { data: priceList, isLoading: isGroupLoading, isError } = useListPriceTypesQuery();
  let today = new Date();
  let yy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  // const navigate = useNavigate();
  const navigate = useControlledNavigation();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  const companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
   const isCessFlag=getCompany?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;
  const userPreferenceAndFY = useSelector((state) => state.userPrefrenceandReducer);
  let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  let [viewState, setViewState] = useState(view);
  let location = useLocation();
  let params = modalEvent === true ? null : location.state;
  useEffect(() => {
    if (viewState && modalEvent === true) {
      params = { view: viewState };
    }
  }, [viewState]);
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/Item/`;
  const viewPage = location.pathname.includes('view');
  const formattedCurrenDate = yy + '-' + mm + '-' + dd;
  const fyStartDate = moment(userPreferenceAndFY.financialYear?.startdate * 1000).format('YYYY-MM-DD');

  const fyEndDate = moment(userPreferenceAndFY.financialYear?.enddate * 1000).format('YYYY-MM-DD');
  const todayDate = moment(formattedCurrenDate).isBetween(fyStartDate, fyEndDate, undefined, '[]') ? yy + '-' + mm + '-' + dd : fyStartDate;
  const DiscountType = [
    { label: '%', value: 1 },
    { label: '₹', value: 2 },
  ];
  const CessTypes = [
    { label: 'Percentage', value: 1 },
    { label: 'Amount', value: 2 },
  ];
  const PriceTypes = [
    { label: 'Wholesale', value: 1 },
    { label: 'Retail', value: 2 },
  ];
  const AllGSTRates = [
    {id:-1,rate:'NIL'},
    { id: 0, rate: '0%' },
    { id: 1, rate: '1%' },
    { id: 2, rate: '2%' },
    { id: 3, rate: '3%' },
    { id: 5, rate: '5%' },
    { id: 6, rate: '6%' },
    { id: 12, rate: '12%' },
    { id: 18, rate: '18%' },
    { id: 28, rate: '28%' },
  ];

  const GStRates =
    getCompany?.relatedcompanydetailsnew?.[0].registrationtype === 3
      ? [
          { id: 1, rate: '1%' },
          { id: 2, rate: '2%' },
          { id: 3, rate: '3%' },
          { id: 5, rate: '5%' },
          { id: 6, rate: '6%' },
        ]
      : [
          { id: 0, rate: '0%' },
          { id: 3, rate: '3%' },
          { id: 5, rate: '5%' },
          { id: 12, rate: '12%' },
          { id: 18, rate: '18%' },
          { id: 28, rate: '28%' },
        ];
  const [selectValue, setSelectValue] = useState(itemType ? itemType : 'GOODS');
  const [units, setUnits] = useState([]);
  const [registrationType, setRegistrationType] = useState('');
  const [companyData, setCompanyData] = useState([]);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [purchaseIndex, setPurchaseIndex] = useState('');
  const [salesIndex, setSalesIndex] = useState('');
  const [purchaseNewFlag, setPurchaseNewFlag] = useState(true);
  const [salesNewFlag, setSalesNewFlag] = useState(true);
  const [purchaseEntryIndex, setPurchaseEntryIndex] = useState('');
  const [salesEntryIndex, setSalesEntryIndex] = useState('');
  const [deletePurchaseEntriesModal, setDeletePurchaseEntriesModal] = useState(false);
  const [deleteSalesEntriesModal, setDeleteSalesEntriesModal] = useState(false);
  const [isFocusPurchase, setIsFocusPurchase] = useState(false);
  const [isFocusSales, setIsFocusSales] = useState(false);
  const [isFocusSalesRow, setIsFocusSalesRow] = useState(false);
  const [isFocusPurchaseRow, setIsFocusPurchaseRow] = useState(false);
  const [amountSalesExcGst, setAmtSalesExcGst] = useState(0);
  const [amountSalesIncGst, setAmtSalesIncGst] = useState(0);
  const [amountPurchaseExcGst, setAmtPurchaseExcGst] = useState(0);
  const [amountPurchaseIncGst, setAmtPurchaseIncGst] = useState(0);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [initialAttachments, setInitialAttachments] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [cancelModal, setCancelModal] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [salesEffectiveToFlag, setSalesEffectiveToFlag] = useState(false);
  const [purchaseEffectiveToFlag, setPurchaseEffectiveToFlag] = useState(false);
  const [taxableValue, setTaxableValue] = useState('');
  const [editSalesFlag, setEditSalesFlag] = useState(false);
  const [editPurchaseFlag, setEditPurchaseFlag] = useState(false);
  const [isPurchaseValid, setPurchaseValid] = useState(true);
  const [isSalesValid, setSalesValid] = useState(true);
  const [isSalesDuplicate, setIsSalesDuplicate] = useState(false);
  const [isPurchaseDuplicate, setIsPurchaseDuplicate] = useState(false);
  const [isSalesActive, setIsSalesActive] = useState(0);
  const [isPurchaseActive, setIsPurchaseActive] = useState(0);
  const [salesFocusCell, setSalesFocusCell] = useState('priceType');
  const [purchaseFocusCell, setPurchaseFocusCell] = useState('priceType');
  const [updatedSalesPrice, setUpdatedSalesPrice] = useState([]);
  const [updatedPurchasePrice, setUpdatedPurchasePrice] = useState([]);
  const [openSalesAccordan, setOpenSalesAccordan] = useState(true);
  const [openPurchaseAccordan, setOpenPurchaseAccordan] = useState(true);
  const [tableErrArr, setTableErrArr] = useState([]);
  const [priceTypeArr, setPriceTypeArr] = useState([]);
  const [priceTypeID, setPriceTypeID] = useState('');
  const [itemUsed, setItemUsed] = useState(false);
  const [checkSalesPriceType, setCheckSalesPriceType] = useState(false);
  const [checkPurchasePriceType, setCheckPurchasePriceType] = useState(false);
  const [deletedPurchaseRows, setDeletedPurchaseRows] = useState([]);
  const [deletedSalesRows, setDeletedSalesRows] = useState([]);
  const [currentDouments, setCurrentDocuments] = useState([]);
  const [currentSalesRows, setCurrentSalesRows] = useState([]);
  const [currentPurchaseRows, setCurrentPurchaseRows] = useState([]);
  const [initialSellingPriceRows, setInitialSellingPriceRows] = useState([]);
  const [initialPurchasePriceRows, setInitialPurchasePriceRows] = useState([]);
  const [initialStateSet, setInitialStateSet] = useState(false);

  // useEffect(() => {
  //   console.log("itemType",itemType);

  //   if (itemType) {
  //     setSelectValue(itemType);
  //   }
  // }, [itemType]);

  const [sellingPriceRows, setSellingPriceRows] = useState([
    {
      id: 0,
      expiredtimestamp: 0,
      amount: 0,
      DiscountType: 1,
      DiscountValue: 0,
      gstRate: { rate: ' ', id: '' },
      cesstype: 1,
      cess: 0,
      amtaftdicount: 0,
      discountAmt: 0,
      priceType: { label: '', value: 0 },
      isActive: 1,
      effectivefrom: '',
      effectiveto: '',
      amountIncludingGst: 0,
      timeStamp: false,
      editable: true,
      new: true,
      order: 1,
      activeType: 1,
      invoiceType: 1,
    },
  ]);
  const [tempSellingPriceRows, setTempSellingPriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 1,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  });
  const [editedSellingPriceRows, setEditedSellingPriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 1,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  });
  const [purchasePriceRows, setPurchasePriceRows] = useState([
    {
      id: 0,
      expiredtimestamp: 0,
      amount: 0,
      DiscountType: 1,
      DiscountValue: 0,
      gstRate: { rate: ' ', id: '' },
      cesstype: 1,
      cess: 0,
      amtaftdicount: 0,
      discountAmt: 0,
      priceType: { label: '', value: 0 },
      isActive: 1,
      effectivefrom: '',
      effectiveto: '',
      amountIncludingGst: 0,
      timeStamp: false,
      editable: true,
      new: true,
      order: 1,
      activeType: 1,
      invoiceType: 2,
    },
  ]);
  const [tempPurchasePriceRows, setTempPurchasePriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 1,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  });
  const [editedPurchasePriceRows, setEditedPurchasePriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 1,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  });
  const newSalesObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 0,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  };
  const newPurchaseObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 0,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  };
  const newActiveSalesObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 1,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  };
  const newActivePurchaseObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: ' ', id: '' },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0 },
    isActive: 1,
    effectivefrom: '',
    effectiveto: '',
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  };
  const [initialState, setInitialState] = useState({
    itemCode: '',
    showItem: page === 'Purchase' && !itemID ? [{ label: 'Purchase', value: 1 }] : [],
    itemName: '',
    voucherSeries: { label: '', value: '' },
    itemCtegorey: selectValue === 'SERVICE' ? '2' : '1',
    unite: '',
    salesAccount: { label: '', value: '' },
    purchaseAccount: page === 'Purchase' && !itemID ? { label: 'Purchase A/c', value: 13 } : { label: '', value: '' },
    taxability: { label:companyType === 3?'Composition - Taxable': 'Taxable', value: 1 },
    hsnCode: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    reverseCharge: '2',
    purchaseInvoice: page === 'Purchase' && !itemID ? 1 : 0,
    salesInvoice: 0,
    fileName: '',
    remarks: '',
    is_active: 1,
    errorStatus: {
      itemCode: false,
      itemName: false,
      unite: false,
      showItem: false,
      salesAccount: false,
      purchaseAccount: false,
      taxability: false,
      voucherSeries: false,

      itemCtegorey: false,

      hsnCode: false,
      reverseCharge: false,
      purchaseInvoice: false,
      salesInvoice: false,
      fileName: false,
      remarks: false,
    },
    errorFields: {
      itemCode: '',
      itemName: '',
      unite: '',
      showItem: '',
      salesAccount: '',
      purchaseAccount: '',
      taxability: '',
      voucherSeries: '',
      itemCtegorey: '',

      hsnCode: '',
      reverseCharge: '',
      purchaseInvoice: '',
      salesInvoice: '',
      fileName: '',
      remarks: '',
    },
  });
  

  const [data, setData] = useState({ ...initialState });
 const responsiveBoxSx = { // LEDX-5531
  borderRadius: '8px',
  transition: 'all 1s ease-in-out',
  ':hover': {
    boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
  },
  pointerEvents:
    data.itemName === '' || data?.showItem?.length === 0 ? 'none' : '',
  '@media (max-width: 1440px)': {
    mt: 2,
    overflowX: 'auto',
    overflowY: 'hidden',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    'table': {
      minWidth: '900px',
    },
  },
  '@media (max-width: 1366px)': {
    mt: 1.5,
    overflowX: 'auto',
    'table': {
      minWidth: '1050px',
    },
  },
  '@media (max-width: 1200px)': {
    'table': {
      minWidth: '1150px',
    },
  },
};


  useEffect(() => {
    if (CategoryID) {
      setData((prev) => ({
        ...prev,
        itemCtegorey: CategoryID.id,
      }));
      setInitialState((prev) => ({
        ...prev,
        itemCtegorey: CategoryID.id,
      }));
    }
  }, [CategoryID]);

  const normalizePriceRows = (rows) => {
    return rows.map((row) => {
      const { timeStamp, editable, new: isNew, order, ...normalizedRow } = row;
      return normalizedRow;
    });
  };

  useEffect(() => {
    setInitialSellingPriceRows([...sellingPriceRows]);
    setInitialPurchasePriceRows([...purchasePriceRows]);
  }, []);

  useEffect(() => {
    if (itemID && sellingPriceRows.length > 0 && sellingPriceRows[0].id !== 0) {
      setInitialSellingPriceRows([...sellingPriceRows]);
    }
  }, [itemID, sellingPriceRows.length > 0 && sellingPriceRows[0].id !== 0]);

  useEffect(() => {
    if (itemID && purchasePriceRows.length > 0 && purchasePriceRows[0].id !== 0) {
      setInitialPurchasePriceRows([...purchasePriceRows]);
    }
  }, [itemID, purchasePriceRows.length > 0 && purchasePriceRows[0].id !== 0]);

  useEffect(() => {
    if (itemID && data.itemName && !initialStateSet) {
      setInitialState({ ...data });
      setInitialStateSet(true);
    }
  }, [itemID, data.itemName, initialStateSet]);

  useEffect(() => {
    setInitialStateSet(false);
  }, [itemID]);

  useEffect(() => {
    setCategoryId(CategoryID);
  }, [CategoryID]);

  const [reNavigate, setReNavigate] = useState('');

  useEffect(() => {
    if (viewPage) {
      dispatch(setNavigationBlocked(false));
      dispatch(setModalBlocked(false));
      return;
    }

    const hasChanges =
      !deepEqual(data, initialState) ||
      attachments.length !== initialAttachments.length ||
      !deepEqual(normalizePriceRows(sellingPriceRows), normalizePriceRows(initialSellingPriceRows)) ||
      !deepEqual(normalizePriceRows(purchasePriceRows), normalizePriceRows(initialPurchasePriceRows));
    dispatch(modalEvent ? setModalBlocked(hasChanges) : setNavigationBlocked(hasChanges));
  }, [
    data,
    attachments,
    initialState,
    initialAttachments,
    sellingPriceRows,
    purchasePriceRows,
    initialSellingPriceRows,
    initialPurchasePriceRows,
    modalEvent,
    viewPage,
  ]);

  console.log({ data, initialState });

  const [aTags, setATags] = useState(document.getElementsByTagName('a').length);
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);

  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    setTimeout(() => {
      setATags(document.getElementsByTagName('a').length);
    }, 50);
  }, [selectorDrawer, selector]);

  //   let a = document.getElementsByTagName("a");
  //   a = [...new Set(a)];
  //   let b = document.getElementsByClassName("pdf");
  //   a.map((e) => {
  //     e?.addEventListener("click", (ev) => {
  //       if (
  //         e.id !== "theme" &&
  //         e.id !== "selectbox" &&
  //         e.id !== "editN" &&
  //         e.id !== "Attachments" &&
  //         !window.location.href.includes("view") &&
  //         e.href !== window.location.href
  //       ) {
  //         const pathname = new URL(e.href)?.pathname;
  //         setReNavigate(pathname);
  //       }
  //     });
  //     e.removeEventListener("click", clickFn);
  //     if (
  //       e.id !== "theme" &&
  //       e.id !== "selectbox" &&
  //       e.id !== "editN" &&
  //       e.id !== "Attachments" &&
  //       !window.location.href.includes("view") &&
  //       e.href !== window.location.href
  //     ) {
  //       e.addEventListener("click", clickFn);
  //     }
  //   });

  //   return () => {
  //     a.map((e) => {
  //       e.removeEventListener("click", clickFn);
  //       e.removeEventListener("click", (ev) => {
  //         setReNavigate(e.href);
  //       });
  //     });
  //   };
  // }, [data, attachments, aTags, attachments]);

  let [modalOpen, setModalOpen] = useState(false);

  async function getCompanyDetails() {
    try {
      if (getCompany !== null) {
        setCompanyData(getCompany);
        setRegistrationType(getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype);
      }
    } catch (error) {
      console.log(error);
    }
  }
  // function formVaidation(objData) {
  //   const itemCodeRegex = /^[0-9a-zA-Z !-\/:-@[-`{-~]+$/;
  //   const itemNameRegex =  /^.*$/;
  //   let isvalid = true;
  //   let errorArr = [];
  //   let obj = { ...data };
  //   Object.keys(data).map((itemKey) => {
  //     if (itemKey === 'itemCode') {
  //           const { valid, message } = CheckVoucherValid(objData[itemKey],'Item Code');
  //       if (objData[itemKey].trim().length <= 0) {
  //         isvalid = false;
  //         obj.errorFields.itemCode = 'Item Code is required';
  //         obj.errorStatus.itemCode = true;
  //         errorArr.push('Item Code');
  //       }
  //       else if(!valid){
  //                  isvalid = false;
  //                 obj.errorFields.itemCode =message;
  //                 obj.errorStatus.itemCode = true;
  //                 showWarningSnackbar(message);
  //               } else {
  //         obj.errorFields.itemCode = '';
  //         obj.errorStatus.itemCode = false;
  //       }
  //     }

  //     if (itemKey === 'itemName') {
  //       if (objData[itemKey].trim().length === 0) {
  //         isvalid = false;
  //         obj.errorFields.itemName = 'Item Name is required';
  //         obj.errorStatus.itemName = true;
  //         errorArr.push('Item Name');
  //       } else if (!itemNameRegex.test(data[itemKey].trim())) {
  //         isvalid = false;
  //         obj.errorFields.itemName = 'Invalid Item Name';
  //         obj.errorStatus.itemName = true;
  //       } else if (data[itemKey].trim().length >= 100) {
  //         isvalid = false;
  //         obj.errorFields.itemName = 'Item Name should be  less than 100 characters';
  //         obj.errorStatus.itemName = true;
  //       } else {
  //         obj.errorFields.itemName = '';
  //         obj.errorStatus.itemName = false;
  //       }
  //     }

  //     if (itemKey === 'unite' && (itemType === 'GOODS' || selectValue === 'GOODS')) {
  //       if (objData[itemKey].trim().length <= 0) {
  //         isvalid = false;
  //         obj.errorFields.unite = 'Unit is required';
  //         obj.errorStatus.unite = true;
  //         errorArr.push('Unit');
  //       } else {
  //         obj.errorFields.unite = '';
  //         obj.errorStatus.unite = false;
  //       }
  //     }

  //     if (itemKey === 'salesAccount') {
  //       if (data.salesInvoice == 1) {
  //         if (objData[itemKey]?.value?.length <= 0) {
  //           isvalid = false;
  //           obj.errorFields.salesAccount = 'Sales Account is required';
  //           obj.errorStatus.salesAccount = true;
  //           errorArr.push('Sales Account');
  //         } else {
  //           obj.errorFields.salesAccount = '';
  //           obj.errorStatus.salesAccount = false;
  //         }
  //       } else {
  //         obj.errorFields.salesAccount = '';
  //         obj.errorStatus.salesAccount = false;
  //       }
  //     }
  //     if (itemKey === 'purchaseAccount') {
  //       if (data.purchaseInvoice == 1) {
  //         if (objData[itemKey]?.value.length <= 0) {
  //           isvalid = false;
  //           obj.errorFields.purchaseAccount = 'Purchase Account is required';
  //           obj.errorStatus.purchaseAccount = true;
  //           errorArr('Purchase Account');
  //         } else {
  //           obj.errorFields.purchaseAccount = '';
  //           obj.errorStatus.purchaseAccount = false;
  //         }
  //       } else {
  //         obj.errorFields.purchaseAccount = '';
  //         obj.errorStatus.purchaseAccount = false;
  //       }
  //     }
  //     if (registrationType !== 1) {
  //       if (itemKey === 'taxability') {
  //         if (objData[itemKey]?.value === '') {
  //           isvalid = false;
  //           obj.errorFields.taxability = 'Taxability is required';
  //           obj.errorStatus.taxability = true;
  //           errorArr.push('Taxability');
  //         } else {
  //           obj.errorFields.taxability = '';
  //           obj.errorStatus.taxability = false;
  //         }
  //       }
  //     }
  //     if (registrationType === 2) {
  //       if (itemKey === 'hsnCode') {
  //         if (objData[itemKey]?.value === '') {
  //           isvalid = false;
  //           obj.errorFields.hsnCode = selectValue === 'GOODS' ? 'HSN Code is required' : 'SAC Code is required';
  //           obj.errorStatus.hsnCode = true;
  //           errorArr.push(selectValue === 'GOODS' ? 'HSN Code' : 'SAC Code');
  //         } else {
  //           obj.errorFields.hsnCode = '';
  //           obj.errorStatus.hsnCode = false;
  //         }
  //       }
  //     }
  //     if (itemKey === 'remarks') {
  //       if (objData[itemKey]?.trim()?.length > 250) {
  //         isvalid = false;
  //         obj.errorFields.remarks = 'Description  must be less than 250 characters';
  //         obj.errorStatus.remarks = true;
  //       } else {
  //         obj.errorFields.remarks = '';
  //         obj.errorStatus.remarks = false;
  //       }
  //     }
  //     if (itemKey === 'showItem') {
  //       if (data?.showItem?.length === 0) {
  //         isvalid = false;
  //         obj.errorFields.showItem = 'Please select the item in Purchase or Sales Invoice';
  //         obj.errorStatus.showItem = true;
  //         errorArr.push('Show Item In Invoice');
  //       } else {
  //         obj.errorFields.showItem = '';
  //         obj.errorStatus.showItem = false;
  //       }
  //     }
  //     setBackdropOpen(false);
  //   });

  //   setData(obj);
  //   if (!isvalid) {
  //     if (errorArr.length === 1) {
  //       showWarningSnackbar(`${errorArr[0]} is required`);
  //     } else {
  //       const lastField = errorArr.pop();
  //       const errorText = `${errorArr?.join(', ')} and ${lastField} are required`;
  //       showWarningSnackbar(errorText);
  //     }
  //   }
  //   return isvalid;
  // }
    function formVaidation(objData) {
  const itemCodeRegex = /^[0-9a-zA-Z !-\/:-@[-`{-~]+$/;
  const itemNameRegex = /^.*$/;
  let isValid = true;
  let errorArr = [];
  let obj = { ...data };

  Object.keys(data).forEach((itemKey) => {

    if (itemKey === 'itemCode') {
      const { valid, message } = CheckVoucherValid(objData[itemKey], 'Item Code');
      const value = objData[itemKey]?.trim() ?? '';

      if (value.length === 0) {
        isValid = false;
        obj.errorFields.itemCode = 'Item Code is required';
        obj.errorStatus.itemCode = true;
        errorArr.push('Item Code');
      } else if (!valid) {
        isValid = false;
        obj.errorFields.itemCode = message;
        obj.errorStatus.itemCode = true;
        showWarningSnackbar(message);
      } else {
        obj.errorFields.itemCode = '';
        obj.errorStatus.itemCode = false;
      }
    }

    if (itemKey === 'itemName') {
      const value = objData[itemKey]?.trim() ?? '';
      if (value.length === 0) {
        isValid = false;
        obj.errorFields.itemName = 'Item Name is required';
        obj.errorStatus.itemName = true;
        errorArr.push('Item Name');
      } else if (!itemNameRegex.test(value)) {
        isValid = false;
        obj.errorFields.itemName = 'Invalid Item Name';
        obj.errorStatus.itemName = true;
      } else if (value.length >= 100) {
        isValid = false;
        obj.errorFields.itemName = 'Item Name must be less than 100 characters';
        showWarningSnackbar('Item Name must be less than 100 characters');
        obj.errorStatus.itemName = true;
      } else {
        obj.errorFields.itemName = '';
        obj.errorStatus.itemName = false;
      }
    }
    if (itemKey === 'unite'
      //  && (itemType === 'GOODS' || selectValue === 'GOODS')
      ) {
      if ((objData[itemKey]?.trim?.() ?? '').length === 0) {
        isValid = false;
        obj.errorFields.unite = 'Unit is required';
        obj.errorStatus.unite = true;
        errorArr.push('Unit');
      } else {
        obj.errorFields.unite = '';
        obj.errorStatus.unite = false;
      }
    }

    if (itemKey === 'salesAccount') {
      if (data.salesInvoice == 1) {
        if (!objData[itemKey]?.value) {
          isValid = false;
          obj.errorFields.salesAccount = 'Sales Account is required';
          obj.errorStatus.salesAccount = true;
          errorArr.push('Sales Account');
        } else {
          obj.errorFields.salesAccount = '';
          obj.errorStatus.salesAccount = false;
        }
      } else {
        obj.errorFields.salesAccount = '';
        obj.errorStatus.salesAccount = false;
      }
    }

    if (itemKey === 'purchaseAccount') {
      if (data.purchaseInvoice == 1) {
        if (!objData[itemKey]?.value) {
          isValid = false;
          obj.errorFields.purchaseAccount = 'Purchase Account is required';
          obj.errorStatus.purchaseAccount = true;
          errorArr.push('Purchase Account');
        } else {
          obj.errorFields.purchaseAccount = '';
          obj.errorStatus.purchaseAccount = false;
        }
      } else {
        obj.errorFields.purchaseAccount = '';
        obj.errorStatus.purchaseAccount = false;
      }
    }

    if (registrationType !== 1 && itemKey === 'taxability') {
      if (!objData[itemKey]?.value) {
        isValid = false;
        obj.errorFields.taxability = 'Taxability is required';
        obj.errorStatus.taxability = true;
        errorArr.push('Taxability');
      } else {
        obj.errorFields.taxability = '';
        obj.errorStatus.taxability = false;
      }
    }

    if (registrationType === 2 && itemKey === 'hsnCode') {
      if (!objData[itemKey]?.value) {
        isValid = false;
        obj.errorFields.hsnCode = selectValue === 'GOODS' ? 'HSN Code is required' : 'SAC Code is required';
        obj.errorStatus.hsnCode = true;
        errorArr.push(selectValue === 'GOODS' ? 'HSN Code' : 'SAC Code');
      } else {
        obj.errorFields.hsnCode = '';
        obj.errorStatus.hsnCode = false;
      }
    }

    if (itemKey === 'remarks') {
      const value = objData[itemKey]?.trim() ?? '';
      if (value.length > 250) {
        isValid = false;
        obj.errorFields.remarks = 'Description must be less than 250 characters';
        obj.errorStatus.remarks = true;
      } else {
        obj.errorFields.remarks = '';
        obj.errorStatus.remarks = false;
      }
    }

    if (itemKey === 'showItem') {
      if (!Array.isArray(data?.showItem) || data?.showItem?.length === 0) {
        isValid = false;
        obj.errorFields.showItem = 'Please select the item in Purchase or Sales Invoice';
        obj.errorStatus.showItem = true;
        errorArr.push('Show Item In Invoice');
      } else {
        obj.errorFields.showItem = '';
        obj.errorStatus.showItem = false;
      }
    }
  });

  setData(obj);
  setBackdropOpen(false);


  if (!isValid && errorArr.length > 0) {
    const uniqueErrors = [...new Set(errorArr)];
    const formattedMessage =
      uniqueErrors.length === 1
        ? `${uniqueErrors[0]} is required`
        : `${uniqueErrors.slice(0, -1).join(', ')} and ${uniqueErrors.slice(-1)} are required`;

    showWarningSnackbar(formattedMessage);
  }

  return isValid;
}

  useEffect(() => {
    let elements = document.getElementsByName(tableErrArr[0]);
    setTimeout(() => {
      if (elements.length > 0) {
        const element = elements[0];
        if (element.tabIndex === -1) {
          element.setAttribute('tabindex', '0');
        }

        element.focus();
      }
    }, 0);
  }, [tableErrArr]);

  async function saveChanges(obj) {
    try {
      if (Freeze === 1) {
        return handleFreeze();
      }
      let itemArr = [];
      let salesArr = [];
      let purchaseArr = [];
      setBackdropOpen(true);
      const { itemCode, itemName, showItem, itemCtegorey, hsnCode, unite, salesAccount, purchaseAccount, taxability, remarks } = data;

      const formData = {
        itemCode,
        itemName,
        showItem,
        hsnCode,
        itemCtegorey,
        unite,
        salesAccount,
        purchaseAccount,
        taxability,
        remarks,
      };

      if (formVaidation(formData)) {
        let isvalid = true;
        let validArr = [];
        let salesValidArr = [];
        let errorArr = [];
        const hasNonEmptyPriceType = sellingPriceRows.some((item) => item?.priceType?.label && item.priceType?.label?.trim() !== '');
        setCheckSalesPriceType(hasNonEmptyPriceType);

        if (data.salesInvoice === 1 && sellingPriceRows.length > 0) {
          sellingPriceRows.map((ele, index) => {
            if (ele?.priceType?.label !== '' || ele?.amount !== 0) {
              if (ele?.priceType?.label === '') {
                salesValidArr.push('Price Type');
                errorArr.push(sellingPriceObj?.priceType + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (ele?.amount == 0 || ele?.amount === '') {
                salesValidArr.push('Rate');
                errorArr.push(sellingPriceObj?.amount + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (registrationType !== 1 && (data?.taxability?.value === 1 || data?.taxability?.value === 4)) {
                if (ele?.gstRate?.id === '') {
                  salesValidArr.push('GST Rate');
                  errorArr.push(sellingPriceObj?.gstRate + `${index}`);
                  setSalesValid(false);
                  isvalid = false;
                }
              }
              if (ele?.effectivefrom === '') {
                  salesValidArr.push('Effective From');
                  errorArr.push(sellingPriceObj?.effectivefrom + `${index}`);
                  setSalesValid(false);
                  isvalid = false;
                }
            }
            if (isvalid) {
              const currentFromDate = moment(ele.effectivefrom, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);
              const currentToDate = moment(ele.effectiveto, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                !currentFromDate.isBefore(currentToDate) &&
                !currentFromDate.isSame(currentToDate, 'day')
              ) {
                isvalid = false;
                showWarningSnackbar('Effective From date must be earlier than Effective To date.');
                setSalesValid(false);
                errorArr.push(sellingPriceObj?.effectivefrom + `${index}`);
                let element = sellingPriceObj?.effectivefrom + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                currentFromDate.isAfter(currentToDate)
              ) {
                isvalid = false;
                showWarningSnackbar('Effective To date must be later than Effective from date.');
                errorArr.push(sellingPriceObj?.effectiveto + `${index}`);
                setSalesValid(false);
                let element = sellingPriceObj?.effectiveto + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }
            }
            return isvalid;
          });
          salesValidArr = [...new Set(salesValidArr)];

          if (salesValidArr.length > 1) {
            showWarningSnackbar(` ${salesValidArr}` + ' ' + ' ' + 'are required');
          }
          if (salesValidArr.length === 1) {
            showWarningSnackbar(` ${salesValidArr}` + ' ' + ' ' + 'is required');
          }
          setOpenSalesAccordan(true);
          setBackdropOpen(false);
        }
        if (data.purchaseInvoice === 1 && purchasePriceRows.length > 0) {
          purchasePriceRows.map((ele, index) => {
            // if (ele?.amount !== 0) {
              if (ele?.priceType?.label !== '' || ele?.amount !== 0) {
                 if (ele?.priceType?.label === '') {
                validArr.push('Price Type');
                errorArr.push(purchasePriceObj?.priceType + `${index}`);
                setPurchaseValid(false);
                isvalid = false;
              }
              if (ele?.amount === 0 || ele?.amount === '') {
                validArr.push('Rate');
                errorArr.push(purchasePriceObj?.amount + `${index}`);
                setPurchaseValid(false);
                isvalid = false;
              }

              if (registrationType !== 1 && (data?.taxability?.value === 1 || data?.taxability?.value === 4)) {
                if (ele?.gstRate?.id === '') {
                  validArr.push('GST Rate');
                  errorArr.push(purchasePriceObj?.gstRate + `${index}`);
                  setPurchaseValid(false);
                  isvalid = false;
                }
              }
                if (ele?.effectivefrom === '') {
                  validArr.push('Effective From');
                  errorArr.push(purchasePriceObj?.effectivefrom + `${index}`);
                  setPurchaseValid(false);
                  isvalid = false;
                }
            }
            if (isvalid) {
              const currentFromDate = moment(ele.effectivefrom, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);
              const currentToDate = moment(ele.effectiveto, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                !currentFromDate.isBefore(currentToDate) &&
                !currentFromDate.isSame(currentToDate, 'day')
              ) {
                isvalid = false;
                showWarningSnackbar('Effective From date must be earlier than Effective To date.');
                errorArr.push(purchasePriceObj?.effectivefrom + `${index}`);
                setPurchaseValid(false);
                let element = purchasePriceObj?.effectivefrom + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                currentFromDate.isAfter(currentToDate)
              ) {
                isvalid = false;
                showWarningSnackbar('Effective To date must be later than Effective from date.');
                setPurchaseValid(false);
                errorArr.push(purchasePriceObj?.effectiveto + `${index}`);
                let element = purchasePriceObj?.effectiveto + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }
            }
            return isvalid;
          });

          validArr = [...new Set(validArr)];

          if (validArr.length > 1) {
            showWarningSnackbar(`${validArr}` + ' are required');
          }
          if (validArr.length === 1) {
            showWarningSnackbar(`${validArr}` + ' is required');
          }

          setOpenSalesAccordan(true);
          setBackdropOpen(false);
        }
        setTableErrArr(errorArr);
        if (isvalid) {
          setPurchaseValid(true);
          setSalesValid(true);
          setBackdropOpen(true);
          const comments = data.remarks;
          const purchaseFlag = data.purchaseInvoice;
          const invoiceFlag = data.salesInvoice;
          const inputData = {
            currencycd: 13,
            hsnid: String(data?.hsnCode.value ? data?.hsnCode.value : 0),
            itemcategorycd: itemCtegorey === '' ? 0 : Number(itemCtegorey),
            itemcode: itemCode,
            itemname: itemName,
            itemtype: selectValue,
            measurementcd: Number(unite),
            purchaseaccountid: purchaseFlag === 0 ? 0 : purchaseAccount.value,
            purchaseinvoiceflag: purchaseFlag,
            reversechargeflag: 0,
            salesaccountid: invoiceFlag === 0 ? 0 : salesAccount.value,
            salesinvoiceflag: invoiceFlag,
            taxabilitycd: taxability.value,
            is_active: 1,
            serialnumber: data.voucherSeries.value,
            description: comments,
          };
          itemArr.push(inputData);
          let salesObj = {};

          if (sellingPriceRows.length > 0) {
            sellingPriceRows.map((ele) => {
              salesObj = {
                amount: ele.amount === '' ? 0 : ele.amount,
                effectivedate: ele.effectivefrom === '' ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
                expireddate: ele.effectiveto === '' ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
                gstcompensationtype: ele.cesstype,
                gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
                gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
                hsnid: String(0),
                invoicetype: ele.invoiceType,
                discounttype: ele.DiscountType,
                discountvalue: ele.DiscountValue,
                isactive: ele.activeType,
                pricetype: ele?.priceType?.label,
                pricetypeid: ele?.priceType?.value ? ele.priceType.value : 0,
                isdefault: ele.isActive,
              };

              salesArr.push(salesObj);
              // }
            });
          } else {
            salesArr.push({
              // id: 0,
              // expiredtimestamp: 0,
              amount: 0,
              effectivedate: 0,

              expireddate: 0,

              gstcompensationtype: 1,
              gstcompensationvalue: 0,
              gstrate: 0,
              hsnid: String(0),
              invoicetype: 1,
              discounttype: 1,
              discountvalue: 0,
              isactive: 1,
              pricetype: '',
              pricetypeid: 0,
              isdefault: 1,
            });
          }
          let purchaseObj = {};

          if (purchasePriceRows.length > 0) {
            purchasePriceRows.map((ele) => {
              purchaseObj = {
                amount: ele.amount === '' ? 0 : ele.amount,
                effectivedate: ele.effectivefrom === '' ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
                expireddate: ele.effectiveto === '' ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
                gstcompensationtype: ele.cesstype,
                gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
                gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
                hsnid: String(0),
                discounttype: ele.DiscountType,
                discountvalue: ele.DiscountValue,
                invoicetype: ele.invoiceType,
                isactive: ele.activeType,
                pricetype: ele?.priceType?.label??'',
                 pricetypeid: ele?.priceType?.value ? ele.priceType.value : 0,
                isdefault: ele.isActive,
              };

              purchaseArr.push(purchaseObj);
              // }
            });
          } else {
            purchaseArr.push({
              // id: 0,
              // expiredtimestamp: 0,
              amount: 0,
              effectivedate: 0,

              expireddate: 0,

              gstcompensationtype: 1,
              gstcompensationvalue: 0,
              gstrate: 0,
              hsnid: String(0),
              invoicetype: 2,
              discounttype: 1,
              discountvalue: 0,
              isactive: 1,
              pricetype: '',
              pricetypeid: 0,
              isdefault: 1,
            });
          }
          let urlArr = attachments?.filter((ele) => {
            if (ele.url !== '') {
              return ele;
            }
          });
          const attachedArr = attachments.map((ele) => ({
            imagename: ele.documentname,
            imageurl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`,
            itemid: itemID,
            documentname: ele.documentname,
            type: ele?.type?.split('/')[1],
          }));
          addnewItem(itemArr, [...purchaseArr, ...salesArr], attachedArr, obj);
        } else {
        }
      } else {
        setErrorArr({ ...data.errorStatus });
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  async function listPriceDetails() {
    try {
      // const res = await API.graphql(graphqlOperation(listPriceType));
      let priceTypArr = [];
      if (priceList !== null) {
        priceList.map((ele) => {
          priceTypArr.push({ label: ele.pricetype, value: ele.id,tabletype:ele.tabletype });
        });
        setPriceTypeArr(priceTypArr);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async function getItemData(itemID) {
    try {
      setSalesNewFlag(true);
      setPurchaseNewFlag(true);
      setBackdropOpen(true);
      let salesObj = {};
      let purchaseObj = {};
      let salesArr = [];
      let purchaseArr = [];
      let gstRate = { label: '', value: '' };
      let priceTypeObj = { label: '', value: 0 ,tabletype:0};
      let totPurchaseAmt = 0;
      let totpurchaseCess = 0;
      let gstPurchaseAmt = 0;
      let discountPurchaseAmt = 0;
      let purchaseEffectiveToFlag = false;
      let salesEffectiveToFlag = false;
      let totSalesAmt = 0;
      let totSalesCess = 0;
      let gstSalesAmt = 0;
      let discountSalesAmt = 0;
      let salesAfterDiscount = 0;
      let purchaseAfterDiscount = 0;
      let salesIsActive = 0;
      let purchaseIsActive = 0;

      const res = await API.graphql(graphqlOperation(getItemmaster, { itemid: itemID }));

      if (res.data.getItemmaster !== null) {
        setItemData(res.data.getItemmaster?.[0]);
        setCategoryId(res.data.getItemmaster?.[0]?.itemcategorycd);
        res.data.getItemmaster?.[0]?.relateditemamountdetails.map((itemEle) => {
          AllGSTRates.map((rate) => {
            if (rate.id === itemEle.gstrate) {
              gstRate = { rate: rate.rate, id: rate?.id };
            }
          });

          if (priceTypeID === '') {
            if (itemEle?.pricetype !== '') {
              priceTypeObj = {
                label: itemEle?.pricetype,
                value: itemEle?.pricetypeid,
                tabletype:itemEle?.tabletype
              };
            } else {
              priceTypeObj = { label: '', value: 0 ,tabletype:0};
            }
          }
          if (itemEle.invoicetype === 1) {
            if (itemEle.amount !== 0) {
              salesIsActive = itemEle?.isdefault;
              discountSalesAmt =
                itemEle.discounttype == 1 ? (Number(itemEle?.amount) * Number(itemEle.discountvalue)) / 100 : Number(itemEle.discountvalue);
              salesAfterDiscount = Number(itemEle?.amount) - Number(discountSalesAmt);
              if (res?.data?.getItemmaster?.[0].taxabilitycd == 4 || registrationType == 1) {
                totSalesCess = 0;
                gstSalesAmt = 0;
              } else {
                if(isCessFlag===0){
                  totSalesCess=0;
                }else{
                totSalesCess =
                  itemEle.gstcompensationtype == 1
                    ? (Number(salesAfterDiscount) * Number(itemEle?.gstcompensationvalue)) / 100
                    : Number(itemEle?.gstcompensationvalue);
                }
                gstSalesAmt = (Number(salesAfterDiscount) * Number(itemEle?.gstrate)) / 100;
                 gstSalesAmt = Number(gstSalesAmt)>0?gstSalesAmt:0;
              }
              totSalesAmt = Number(itemEle?.amount) - Number(discountSalesAmt) + Number(gstSalesAmt) + Number(totSalesCess);
           

              salesObj = {
                id: itemEle?.id,
                expiredtimestamp: itemEle?.expiredtimestamp,
                amount: itemEle.amount,
                DiscountType: itemEle.discounttype,
                DiscountValue: itemEle.discountvalue,
                gstRate: gstRate,
                effectivefrom: moment.unix(itemEle.effectivedate).format('YYYY-MM-DD'),
                effectiveto: itemEle.expireddate !== 0 ? moment.unix(itemEle.expireddate).format('YYYY-MM-DD') : 0,
                cesstype: itemEle.gstcompensationtype == 1 ? 1 : 2,
                cess: itemEle.gstcompensationvalue,
                amtaftdicount: salesAfterDiscount,
                discountAmt: discountSalesAmt,
                amountIncludingGst:
                  getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype === 3 ? Number(salesAfterDiscount) : Number(totSalesAmt),
                new: false,
                invoiceType: 1,
                activeType: itemEle.isactive,
                isActive: itemEle.isdefault,

                priceType: priceTypeObj,
              };

              salesArr.push(salesObj);
            }
          }
          if (itemEle.invoicetype === 2) {
            if (itemEle.amount !== 0) {
              purchaseIsActive = itemEle?.isdefault;
              discountPurchaseAmt =
                itemEle.discounttype == 1 ? (Number(itemEle?.amount) * Number(itemEle.discountvalue)) / 100 : Number(itemEle.discountvalue);
              purchaseAfterDiscount = Number(itemEle?.amount) - Number(discountPurchaseAmt);
              if (registrationType == 1) {
                totSalesCess = 0;
                gstSalesAmt = 0;
              } else {
                if(isCessFlag===0){
                  totpurchaseCess=0;
                }else{
                totpurchaseCess =
                  itemEle.gstcompensationtype == 1
                    ? (Number(purchaseAfterDiscount) * Number(itemEle?.gstcompensationvalue)) / 100
                    : Number(itemEle?.gstcompensationvalue);
                }

                gstPurchaseAmt = (Number(purchaseAfterDiscount) * Number(itemEle?.gstrate)) / 100;
                gstPurchaseAmt=Number(gstPurchaseAmt)>0?gstPurchaseAmt:0;
              }
              totPurchaseAmt = Number(itemEle?.amount) - Number(discountPurchaseAmt) + Number(gstPurchaseAmt) + Number(totpurchaseCess);
             
              purchaseObj = {
                id: itemEle?.id,
                expiredtimestamp: itemEle.expiredtimestamp,
                amount: itemEle.amount,
                DiscountType: itemEle.discounttype,
                DiscountValue: itemEle.discountvalue,
                gstRate: gstRate,
                effectivefrom: moment.unix(itemEle.effectivedate).format('YYYY-MM-DD'),
                effectiveto: itemEle.expireddate !== 0 ? moment.unix(itemEle.expireddate).format('YYYY-MM-DD') : '',
                cesstype: itemEle.gstcompensationtype == 1 ? 1 : 2,
                cess: itemEle.gstcompensationvalue,
                amtaftdicount: purchaseAfterDiscount,
                discountAmt: discountPurchaseAmt,
                amountIncludingGst: Number(totPurchaseAmt),
                new: false,
                invoiceType: 2,
                activeType: itemEle.isactive,
                isActive: itemEle.isdefault,
                priceType: priceTypeObj,
              };

              purchaseArr.push(purchaseObj);
            }
          }
        });
        setIsPurchaseActive(purchaseIsActive);
        setIsSalesActive(salesIsActive);

        if (salesArr.length > 0 && priceTypeID === '') {
          salesArr.map((ele) => {
            if (ele.effectiveto === '') {
              salesEffectiveToFlag = true;
            }
          });
          let updatedSalesRows = [...salesArr, newSalesObj];
          setUpdatedSalesPrice(updatedSalesRows);
          setSellingPriceRows(updatedSalesRows);
          setCurrentSalesRows(updatedSalesRows);
          setInitialSellingPriceRows(updatedSalesRows);
        }
        if (purchaseArr.length > 0 && priceTypeID === '') {
          purchaseArr.map((ele) => {
            if (ele.effectiveto === '') {
              purchaseEffectiveToFlag = true;
            }
          });
          let updatedPurchaseRows = [...purchaseArr, newPurchaseObj];
          setUpdatedPurchasePrice(updatedPurchaseRows);
          setPurchasePriceRows(updatedPurchaseRows);
          setCurrentPurchaseRows(updatedPurchaseRows);
          setInitialPurchasePriceRows(updatedPurchaseRows);
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  const [itemBasicKey, setitemBasicKey] = useState(1);

  async function addnewItem(data1, data2, data3, obj) {
    try {
      const resItem = await API.graphql(
        graphqlOperation(createItemTransaction, {
          createItemTransactionInput: {
            itemmaster: data1,
            itemamountdetails: data2,
            itemimages: data3,
          },
        })
      );
      if (resItem.data.createItemTransaction.statuscode === 'Error') {
        setBackdropOpen(false);
        showWarningSnackbar(resItem.data.createItemTransaction.statusmessage);
      } else {
        let responses =
          attachments?.map((element) => {
            if (element.file) {
              let url = element.imagename.replace('${id}', resItem.data.createItemTransaction?.itemid);
              return uploadToServer(element.file, url, element.type);
            }
          }) || [];
        dispatch(
          VoucherSettingsApi.util.invalidateTags([
            {
              type: 'listVoucherSettings',
              id: selectValue === 'GOODS' ? 'Item' : 'Service',
            },
          ])
        );
        dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
        await Promise.all(responses);
        if (modalEvent) {
          showSuccessSnackbar('Item Created Successfully');
          dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemMaster']));

          closeModal(false, 'force');
          if (setItemID) {
            setItemID(resItem.data.createItemTransaction.itemid);
          }
          let promises = [listItems(resItem.data.createItemTransaction.itemcode, 0, 20)];
          await Promise.all(promises);
          getItems(resItem.data.createItemTransaction.itemid, rowIndex);
        } else {
          showSuccessSnackbar('Item Created Successfully');
          dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemMaster']));
          if (obj.new === false) {
            navigate('/newItemList', { force: true });
          } else {
            let a = { ...initialState };
            setCategoryId({ id: mainCategoryId });
            reset(a);
            let obj = {
              id: 0,
              expiredtimestamp: 0,
              amount: 0,
              DiscountType: 1,
              DiscountValue: 0,
              gstRate: { rate: ' ', id: '' },
              cesstype: 1,
              cess: 0,
              amtaftdicount: 0,
              discountAmt: 0,
              priceType: { label: '', value: 0,tabletype:0 },
              isActive: 1,
              effectivefrom: '',
              effectiveto: '',
              amountIncludingGst: 0,
              timeStamp: false,
              editable: true,
              new: true,
              order: 1,
              activeType: 1,
              invoiceType: 1,
            };
            setSellingPriceRows([obj]);

            setPurchasePriceRows([obj]);
            setAttachments([]);
          }
        }
        dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemMaster']));
      }
    } catch (error) {
      console.log('error', error);
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];

      setBackdropOpen(false);
      showWarningSnackbar(errorMessage);
    } finally {
      if (modalEvent) {
        dispatch(setModalBlocked(false));
      } else {
        dispatch(setNavigationBlocked(false));
      }
    }
  }
  async function saveEditChanges(obj, active, nav, cancel) {
    try {
      if (Freeze === 1) {
        return handleFreeze();
      }
      setBackdropOpen(true);
      const { itemCode, itemName, showItem, hsnCode, itemCtegorey, unite, salesAccount, purchaseAccount, taxability } = data;

      const formData = {
        itemCode,
        showItem,
        itemName,
        hsnCode,
        itemCtegorey,
        unite,
        salesAccount,
        purchaseAccount,
        taxability,
      };

      if (formVaidation(formData)) {
        let isvalid = true;
        let validArr = [];
        let salesValidArr = [];
        let errorArr = [];
        const hasNonEmptyPriceType = sellingPriceRows.some((item) => item?.priceType?.label && item.priceType?.label?.trim() !== '');
        setCheckSalesPriceType(hasNonEmptyPriceType);

        if (data.salesInvoice === 1 && sellingPriceRows.length > 0) {
          sellingPriceRows.map((ele, index) => {
            if (ele?.priceType?.label !== '' || ele?.amount !== 0) {
              if (ele?.priceType?.label === '') {
                salesValidArr.push('Price Type');
                errorArr.push(sellingPriceObj?.priceType + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (ele?.amount == 0 || ele?.amount === '') {
                salesValidArr.push('Rate');
                errorArr.push(sellingPriceObj?.amount + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (registrationType !== 1 && (data?.taxability?.value === 1 || data?.taxability?.value === 4)) {
                if (ele?.gstRate?.id === '') {
                  salesValidArr.push('GST Rate');
                  errorArr.push(sellingPriceObj?.gstRate + `${index}`);
                  setSalesValid(false);
                  isvalid = false;
                }
              }
               if (ele?.effectivefrom === '') {
                  salesValidArr.push('Effective From');
                  errorArr.push(sellingPriceObj?.effectivefrom + `${index}`);
                  setSalesValid(false);
                  isvalid = false;
                }
            }
            if (isvalid) {
              const currentFromDate = moment(ele.effectivefrom, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);
              const currentToDate = moment(ele.effectiveto, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                !currentFromDate.isBefore(currentToDate) &&
                !currentFromDate.isSame(currentToDate, 'day')
              ) {
                isvalid = false;
                showWarningSnackbar('Effective From date must be earlier than Effective To date.');
                setSalesValid(false);
                errorArr.push(sellingPriceObj?.effectivefrom + `${index}`);
                let element = sellingPriceObj?.effectivefrom + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                currentFromDate.isAfter(currentToDate)
              ) {
                isvalid = false;
                showWarningSnackbar('Effective To date must be later than Effective from date.');
                errorArr.push(sellingPriceObj?.effectiveto + `${index}`);
                setSalesValid(false);
                let element = sellingPriceObj?.effectiveto + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }
            }
            return isvalid;
          });
          salesValidArr = [...new Set(salesValidArr)];

          if (salesValidArr.length > 1) {
            showWarningSnackbar(` ${salesValidArr}` + ' ' + ' ' + 'are required');
          }
          if (salesValidArr.length === 1) {
            showWarningSnackbar(` ${salesValidArr}` + ' ' + ' ' + 'is required');
          }
          setOpenSalesAccordan(true);
          setBackdropOpen(false);
        }
        if (data.purchaseInvoice === 1 && purchasePriceRows.length > 0) {
          purchasePriceRows.map((ele, index) => {
            // if (ele?.amount !== 0) {
             if (ele?.priceType?.label !== '' || ele?.amount !== 0) {
                 if (ele?.priceType?.label === '') {
                validArr.push('Price Type');
                errorArr.push(purchasePriceObj?.priceType + `${index}`);
                setPurchaseValid(false);
                isvalid = false;
              }
              if (ele?.amount === 0 || ele?.amount === '') {
                validArr.push('Rate');
                errorArr.push(purchasePriceObj?.amount + `${index}`);
                setPurchaseValid(false);
                isvalid = false;
              }

              if (registrationType !== 1 && (data?.taxability?.value === 1 || data?.taxability?.value === 4)) {
                if (ele?.gstRate?.id === '') {
                  validArr.push('GST Rate');
                  errorArr.push(purchasePriceObj?.gstRate + `${index}`);
                  setPurchaseValid(false);
                  isvalid = false;
                }
              }
               if (ele?.effectivefrom === '') {
                  validArr.push('Effective From');
                  errorArr.push(purchasePriceObj?.effectivefrom + `${index}`);
                  setPurchaseValid(false);
                  isvalid = false;
                }
            }
            if (isvalid) {
              const currentFromDate = moment(ele.effectivefrom, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);
              const currentToDate = moment(ele.effectiveto, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                !currentFromDate.isBefore(currentToDate) &&
                !currentFromDate.isSame(currentToDate, 'day')
              ) {
                isvalid = false;
                showWarningSnackbar('Effective From date must be earlier than Effective To date.');
                errorArr.push(purchasePriceObj?.effectivefrom + `${index}`);
                setPurchaseValid(false);
                let element = purchasePriceObj?.effectivefrom + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }

              if (
                ele.effectiveto &&
                ele.effectiveto !== 0 &&
                currentFromDate.isValid() &&
                currentToDate.isValid() &&
                currentFromDate.isAfter(currentToDate)
              ) {
                isvalid = false;
                showWarningSnackbar('Effective To date must be later than Effective from date.');
                setPurchaseValid(false);
                errorArr.push(purchasePriceObj?.effectiveto + `${index}`);
                let element = purchasePriceObj?.effectiveto + `${index}`;
                const prevElement = document.getElementById(element);
                prevElement?.focus();
              }
            }
            return isvalid;
          });

          validArr = [...new Set(validArr)];

          if (validArr.length > 1) {
            showWarningSnackbar(`${validArr}` + ' are required');
          }
          if (validArr.length === 1) {
            showWarningSnackbar(`${validArr}` + ' is required');
          }
          setBackdropOpen(false);
          setOpenSalesAccordan(true);
        }
        if (isvalid) {
          const comments = data?.remarks;
          const purchaseFlag = data.purchaseInvoice;
          const invoiceFlag = data.salesInvoice;

          const inputData = {
            currencycd: '13',
            itemcategorycd: itemCtegorey == '' ? 0 : Number(itemCtegorey),
            itemcode: itemCode,
            itemid: itemData.itemid,
            hsnid: String(
              data?.hsnCode.value === '' || data?.hsnCode?.value === undefined || data?.hsnCode?.value === null ? 0 : data?.hsnCode?.value
            ),
            itemname: itemName,
            itemtype: selectValue,
            measurementcd: Number(unite),
            purchaseaccountid: purchaseFlag === 0 ? 0 : purchaseAccount.value,
            purchaseinvoiceflag: purchaseFlag,
            reversechargeflag: 0,
            salesaccountid: invoiceFlag === 0 ? 0 : salesAccount.value,
            salesinvoiceflag: invoiceFlag,
            taxabilitycd: taxability.value,
            serialnumber: data?.voucherSeries.value,
            is_active: active,
            description: comments,
            expiredtimestamp: 0,
            companyid: getCompany?.companyid,
            financialyearid: userPreferece?.financialYear?.financialyearid,
            lastupdatedby: '',
          };

          // if (active && active == "active") {
          //   let passData = {
          //     ...inputData,
          //     is_active: data.is_active == 0 ? 1 : 0,
          //   };
          //   activeInSActive(passData);
          // } else
          updateItem(inputData, obj, active, nav, cancel);
        } else {
          setTableErrArr(errorArr);
        }
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  // let activeInSActive = async (inputData) => {
  //   try {
  //     setBackdropOpen(true);

  //     const res = await API.graphql(
  //       graphqlOperation(createItemMaster, { createItemMasterInput: inputData })
  //     );
  //     if (res.data.createItemMaster !== null) {
  //       showSuccessSnackbar(
  //         `Item marked as ${inputData.is_active == 0 ? "inactive" : "active"} `
  //       );

  //       if (!params?.view) {
  //         if (modalEvent == true) {
  //           if (closeModal) {
  //             return closeModal(false);
  //           }
  //         }
  //         navigate("/newItemList");
  //       } else {
  //         getCompanyDetails();
  //         listUserPreferenceData();
  //         listPriceDetails();
  //       }
  //     }
  //   } catch (e) {
  //     setBackdropOpen(false);
  //     console.log(e, "error");
  //   }
  // };

  async function updateItem(inputData, obj, active, nav, cancel) {
    setBackdropOpen(true);
    try {
      let salesObj = {};
      let purchaseObj = {};
      let arr = [];
      let purchaseRows = [...purchasePriceRows, ...deletedPurchaseRows];
      let salesRows = [...sellingPriceRows, ...deletedSalesRows];

      Math.floor(new Date().getTime() / 1000);

      let currentTimesStamp = Math.floor(new Date().getTime() / 1000);
      if (data?.salesInvoice === 0) {
        if (updatedSalesPrice?.length > 0) {
          let deletedArr = [...updatedSalesPrice].map((item, ind) => {
            return { ...item, expiredtimestamp: currentTimesStamp };
          });

          salesRows = [...sellingPriceRows, ...deletedSalesRows, ...deletedArr];
        }
      }
      if (data?.purchaseInvoice === 0) {
        if (updatedPurchasePrice?.length > 0) {
          let deletedArr = [...updatedPurchasePrice].map((item, ind) => {
            return { ...item, expiredtimestamp: currentTimesStamp };
          });

          purchaseRows = [...purchasePriceRows, ...deletedPurchaseRows, ...deletedArr];
        }
      }

      if (salesRows.length > 0) {
        salesRows.map((ele) => {
          salesObj = {
            id: ele?.id ? ele?.id : 0,
            amount: ele.amount === '' ? 0 : ele.amount,
            effectivedate:
              ele.effectivefrom === '' || isNaN(Date.parse(ele.effectivefrom)) ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
            expireddate: ele.effectiveto === '' || isNaN(Date.parse(ele.effectiveto)) ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
            gstcompensationtype: String(ele.cesstype),
            gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
            gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
            hsnid: 0,
            itemid: itemData?.itemid,
            discounttype: ele.DiscountType,
            discountvalue: ele.DiscountValue,
            invoicetype: ele.invoiceType,
            isactive: ele.activeType,
            pricetype: ele?.priceType?.label,
             pricetypeid: ele?.priceType?.value ? ele.priceType.value : 0,
            isdefault: ele.isActive,
            expiredtimestamp: data?.salesInvoice === 0 ? currentTimesStamp : ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: getCompany?.companyid,
          };
          arr.push(salesObj);
        });
      } else {
        arr.push({
          id: 0,
          expiredtimestamp: 0,
          amount: 0,
          effectivedate: 0,

          expireddate: 0,
          itemid: itemData?.itemid,
          gstcompensationtype: '1',
          gstcompensationvalue: 0,
          gstrate: 0,
          hsnid: 0,
          invoicetype: 1,
          discounttype: 1,
          discountvalue: 0,
          isactive: 1,
          pricetype: '',
          pricetypeid: 0,
          isdefault: 1,

          companybranchid: getCompany?.companyid,
        });
      }

      if (purchaseRows.length > 0) {
        purchaseRows.map((ele) => {
          purchaseObj = {
            id: ele?.id ? ele?.id : 0,
            amount: ele.amount === '' ? 0 : ele.amount,
            effectivedate:
              ele.effectivefrom === '' || isNaN(Date.parse(ele.effectivefrom)) ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
            expireddate: ele.effectiveto === '' || isNaN(Date.parse(ele.effectiveto)) ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
            gstcompensationtype: String(ele.cesstype),
            gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
            gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
            hsnid: 0,
            itemid: itemData?.itemid,
            discounttype: ele.DiscountType,
            discountvalue: ele.DiscountValue,
            invoicetype: ele.invoiceType,
            isactive: ele.activeType,
             pricetype: ele?.priceType?.label??'',
                 pricetypeid: ele?.priceType?.value ? ele.priceType.value : 0,
            isdefault: ele.isActive,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: getCompany?.companyid,
          };
          arr.push(purchaseObj);
        });
      } else {
        arr.push({
          id: 0,
          expiredtimestamp: 0,
          amount: 0,
          effectivedate: 0,
          itemid: itemData?.itemid,
          expireddate: 0,

          gstcompensationtype: '1',
          gstcompensationvalue: 0,
          gstrate: 0,
          hsnid: 0,
          invoicetype: 2,
          discounttype: 1,
          discountvalue: 0,
          isactive: 1,
          pricetype: '',
          isdefault: 1,
          pricetypeid: 0,

          companybranchid: getCompany?.companyid,
        });
      }

      Math.floor(new Date().getTime() / 1000);
      const exp = Math.floor(new Date().getTime() / 1000);
      const idsInArray2 = new Set(attachments.map((item) => item.attachmentid));

      let arratt = [];
      const updatedArray1 = currentDouments.map((item) => {
        let arr;
        if (!idsInArray2.has(item.attachmentid) && typeof item.attachmentid !== 'string') {
          arr = { ...item, expiredtimestamp: exp };
          arratt.push(arr);
        } else {
          // arr = attachments[item.attachmentid] || item;
          arr = attachments.find((att) => att.attachmentid === item.attachmentid);
          arratt.push(arr);
        }
      });

      const additionalItems = attachments.filter((item2) => !currentDouments.some((item1) => item1.attachmentid == item2.attachmentid));

      const finalArray = [...arratt, ...additionalItems];
      const attachedArr = finalArray.map((ele, ind) => {
        if (ele.file) {
          ele.imageurl = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`;
          ele.imagename = ele.imagename?.replace('${id}', itemData?.itemid);
          if (ele.file) {
            uploadToServer(ele.file, ele.imagename, ele.type);
          }
        }
        return {
          imagename: ele.imagename,
          imageurl: `${ele.imageurl?.replace('${id}', itemData?.itemid)}`,
          itemid: itemData?.itemid,
          documentname: ele.documentname,
          type: ele?.type,
          expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
          companybranchid: getCompany?.companyid,
          attachmentid: typeof ele.attachmentid === 'string' ? 0 : ele.attachmentid,
        };
      });
      await Promise.all(attachedArr);
      let variables = {};
      if (attachedArr.length > 0) {
        variables = {
          createItemMasterInput: inputData,
          createItemAmountDetailsInput: arr,
          createItemImagesInput: attachedArr,
        };
      } else {
        variables = {
          createItemMasterInput: inputData,
          createItemAmountDetailsInput: arr,
        };
      }

      const response = await API.graphql(
        graphqlOperation(attachedArr.length > 0 ? createItemMasterWithDetailsAndImages : createItemMasterWithDetails, variables)
      );

      if (response.data !== null) {
        dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemMaster']));
        if (modalEvent) {
          if (listItems) {
            let promises = [listItems(response.data.createItemMaster.itemcode, 0, 20)];
            await Promise.all(promises);
          }
          if (getItems) {
            getItems(response.data.createItemMaster.itemid, rowIndex);
          }
          if (cancel === 'cancel') {
            params = { view: false };
            setViewState(false);
          } else {
            closeModal(false, 'force');
          }
        } else {
          if (modalEvent == true) {
            if (closeModal) {
              return closeModal(false, 'force');
            }
          }
          if (obj.new) {
            setData((prev) => ({
              ...prev,
              is_active: 1,
            }));
            setBackdropOpen(false);
          } else if (active == 1 && nav == true) {
            navigate('/edititem', {
              force: true,
              state: { id: params?.id, view: false, type: params?.type },
            });
          } else {
            navigate('/newItemList', { force: true });
          }
        }

        if (cancel) {
          showSuccessSnackbar(`Item marked as ${active == 1 ? 'active' : 'inactive'}`);
        } else {
          showSuccessSnackbar('Item Updated Successfully');
        }
      }
    } catch (error) {
      console.log('error', error);
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showErrorSnackbar(errorMessage);
    } finally {
      if (modalEvent) {
        dispatch(setModalBlocked(false));
      } else {
        dispatch(setNavigationBlocked(false));
      }
      setBackdropOpen(false);
    }
  }

  async function listUserPreferenceData() {
    try {
      let attributeValue = userPreferece?.financialYear?.financialyearid;

      getFY(attributeValue);
    } catch (error) {
      console.log('error', error);
    }
  }

  async function getFY(data) {
    try {
      let startDate = new Date(userPreferece.financialYear?.startdate * 1000).toString()?.split(' ');
      let endDate = new Date(Number(userPreferece.financialYear?.enddate) * 1000).toString()?.split(' ');
      setStartDate(startDate);
      setEndDate(endDate);
    } catch (error) {
      console.log('Error', error);
    }
  }

  function reset(value) {
    let valueData = value == undefined ? initialState : value;
    setitemBasicKey((prev) => prev + 1);
    setData(valueData);

    setData((prev) => ({
      ...prev,
      itemCode: '',

      showItem: [],
      itemName: '',
      voucherSeries: { label: '', value: '' },
      itemCtegorey: value?.itemCtegorey,
      unite: '',
      salesAccount: { label: '', value: '' },
      purchaseAccount: { label: '', value: '' },
      taxability: { label:companyType === 3?'Composition - Taxable': 'Taxable', value: 1 },
      hsnCode: {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      },
      reverseCharge: '2',
      purchaseInvoice: 0,
      salesInvoice: 0,
      fileName: '',
      remarks: '',
      is_active: 1,
      errorStatus: {
        ...prev.errorStatus,
        itemCode: false,
        voucherSeries: false,
        showItem: false,
        itemName: false,
        itemCtegorey: false,
        unite: false,
        salesAccount: false,
        purchaseAccount: false,
        taxability: false,
        hsnCode: false,
        reverseCharge: false,
        purchaseInvoice: false,
        salesInvoice: false,
        fileName: false,
        remarks: false,
      },
      errorFields: {
        ...prev.errorFields,
        itemCode: '',
        showItem: '',
        voucherSeries: '',
        itemName: '',
        itemCtegorey: '',
        unite: '',
        salesAccount: '',
        purchaseAccount: '',
        taxability: '',
        hsnCode: '',
        reverseCharge: '',
        purchaseInvoice: '',
        salesInvoice: '',
        fileName: '',
        remarks: '',
      },
    }));
    setSellingPriceRows([newActiveSalesObj]);
    setPurchasePriceRows([newActivePurchaseObj]);
  }
  useEffect(() => {
    getCompanyDetails();
    listUserPreferenceData();
  }, []);
  useEffect(() => {
    listPriceDetails();
  }, [priceList]);
  useEffect(() => {
    if (itemID || params) {
      getItemData(itemID || params?.id);
      if (params?.id !== '' && params?.id !== undefined && params?.id !== null) {
        if (params?.taxType == 2 || params?.taxType == 3 || params?.taxType == 5) {
          setRegistrationType(1);
        }

        setSelectValue(params?.type === 2 ? 'SERVICE' : 'GOODS');
      }
    }
  }, [itemID, params]);
  useEffect(() => {
    if (sellingPriceRows.length === 1 && editSalesFlag === false) {
      setEditedSellingPriceRows(newActiveSalesObj);
    }
    if (purchasePriceRows.length === 1 && editPurchaseFlag === false) {
      setEditedPurchasePriceRows(newActivePurchaseObj);
    }
    if (sellingPriceRows.length === 0) {
      setSalesEffectiveToFlag(false);
    }
    if (purchasePriceRows.length === 0) {
      setPurchaseEffectiveToFlag(false);
    }
  }, [sellingPriceRows, purchasePriceRows]);

  const radioRef = useRef(null);
  const radioRef2 = useRef(null);
  useEffect(() => {
    if (radioRef.current && selectValue !== 'GOODS') {
      radioRef.current.focus();
    } else if (radioRef2.current && selectValue == 'GOODS') {
      radioRef2.current.focus();
    }
  }, [selectValue]);
  const [errorArr, setErrorArr] = useState({});
  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }

      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);

        element?.focus();
      }
    }
  }, [errorArr]);

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const ids = ['addCategory', 'addUnit', 'SettingsModal', 'deleteCategory', 'AddItemsAccountModal', 'AddHSNModal', 'CreatePriceType'];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);

  useSaveShortcut(
    (itemID || params?.id) && params?.view !== true && viewState !== true
      ? () => {
          if (!anyElementExists()) saveEditChanges({ new: false }, 1, false);
        }
      : params?.view !== true && viewState !== true
      ? () => {
          if (!anyElementExists()) saveChanges({ new: false });
        }
      : undefined
  );
  return (
    <Box className="darkDisabledInputs">
      <Box className="PageHeight">
        {modalOpen && <ConfirmExit open={modalOpen} setOpen={setModalOpen} reNavigate={reNavigate} />}
        {!itemID && page !== 'Dashboard' && (
          <Box
            sx={{
              borderRadius: '8px',
              // backgroundColor: "background.paper",
              marginBottom: '24px',
              // mt:3,
              // boxShadow:
              //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
              // padding: { xs: "10px 0px", sm: "10px 10px" },

              ':hover': {
                boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
              },
              transition: 'all 1s ease-in-out',
            }}
          >
            {' '}
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                sx={{
                  border: '2px solid transparent',
                  pl: '5px',
                  '&:focus-within': {
                    borderColor: 'primary.main',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderRadius: '4px',
                  },
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.stopPropagation();
                    event.preventDefault();
                    setSelectValue(selectValue == 'GOODS' ? 'SERVICE' : 'GOODS');
                  }
                }}
              >
                <FormControlLabel
                  onChange={() => {
                    setSelectValue('GOODS');
                    let a = { ...initialState };
                    a.itemCtegorey = '1';
                    setInitialState(a);

                    reset(a);
                  }}
                  checked={selectValue == 'GOODS' || itemType == 'GOODS' ? true : false}
                  disabled={itemID || params !== null ? true : false}
                  value={selectValue}
                  control={<Radio autoFocus disableRipple={false} disableFocusRipple={false} ref={radioRef2} />}
                  label="GOODS"
                />
                <FormControlLabel
                  onChange={() => {
                    setSelectValue('SERVICE');
                    let a = { ...initialState };
                    a.itemCtegorey = '2';
                    setInitialState(a);
                    reset(a);
                  }}
                  checked={selectValue == 'SERVICE' || itemType == 'SERVICE' ? true : false}
                  disabled={
                    itemID || itemID || params !== null
                      ? // ||(modalEvent && page === "Purchase")
                        true
                      : false
                  }
                  value="SERVICE"
                  control={<Radio autoFocus disableRipple={false} disableFocusRipple={false} ref={radioRef} />}
                  label="SERVICE"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        )}
        <Box
          className={params?.view === true ? 'disable-interactions' : ''}
          sx={{
            borderRadius: '8px',
            // backgroundColor: "background.paper",
            // marginBottom: "10px",
            mt: 3,
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // padding: { xs: "10px 0px", sm: "10px 10px" },

            ':hover': {
              boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            },
            transition: 'all 1s ease-in-out',
          }}
        >
          <ItemBasicDetails
            view={viewState}
            key={itemBasicKey}
            mainCategoryId={mainCategoryId}
            setMainCategoryId={setMainCategoryId}
            setCategoryId={setCategoryId}
            categoryId={categoryId}
            Type={selectValue}
            data={data}
            setData={setData}
            setInitialState={setInitialState}
            units={units}
            setUnits={setUnits}
            companyData={companyData}
            registrationType={registrationType}
            fyID={userPreferenceAndFY?.financialYear?.FinancialYearID}
            setRegistrationType={setRegistrationType}
            setBackdropOpen={setBackdropOpen}
            itemData={itemData}
            setTaxableValue={setTaxableValue}
            page={page}
            itemID={itemID}
            setAccNames={setAccNames}
            newSalesObj={newActiveSalesObj}
            newPurchaseObj={newActivePurchaseObj}
            updatedPurchasePrice={updatedPurchasePrice}
            updatedSalesPrice={updatedSalesPrice}
            setSellingPriceRows={setSellingPriceRows}
            setPurchasePriceRows={setPurchasePriceRows}
            setTempPurchasePriceRows={setTempPurchasePriceRows}
            setTempSellingPriceRows={setTempSellingPriceRows}
            setEditedPurchasePriceRows={setEditedPurchasePriceRows}
            setEditedSellingPriceRows={setEditedSellingPriceRows}
            sellingPriceRows={sellingPriceRows}
            purchasePriceRows={purchasePriceRows}
            setUpdatedPurchasePrice={setUpdatedPurchasePrice}
            setUpdatedSalesPrice={setUpdatedSalesPrice}
            setTableErrArr={setTableErrArr}
            setSalesValid={setSalesValid}
            setPurchaseValid={setPurchaseValid}
            sellingPriceObj={sellingPriceObj}
            purchasePriceObj={purchasePriceObj}
            modalEvent={modalEvent}
          />
        </Box>

        <Box
          // className={
          //   data?.salesAccount?.value === "" || params?.view === true
          //     ? "disable-interactions !important"
          //     : "none !important"
          // }
          className="custom-scrollbar"
          // sx={{
          //   borderRadius: '8px',
          //   // backgroundColor: "background.paper",
          //   // marginBottom: "20px",
          //   mt: 3,
          //   //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          //   // padding: { xs: "10px 0px", sm: "10px 10px" },

          //   ':hover': {
          //     boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
          //   },
          //   transition: 'all 1s ease-in-out',
          //   pointerEvents: data.itemName === '' || data?.showItem?.length === 0 ? 'none' : '',
          // }}
          sx={{responsiveBoxSx}} // //LEDX-5531
        >
          <NewSellingPriceTable
            key={itemBasicKey}
            Type={selectValue}
            tableType="Sales"
            rows={sellingPriceRows}
            tempRow={tempSellingPriceRows}
            editedRow={editedSellingPriceRows}
            setRows={setSellingPriceRows}
            setEditedRow={setEditedSellingPriceRows}
            setTempRow={setTempSellingPriceRows}
            data={data}
            companyData={companyData}
            registrationType={registrationType}
            endDate={endDate}
            startDate={startDate}
            setNewItemRowStatus={setSalesNewFlag}
            newItemRowStatus={salesNewFlag}
            setIsFocusItem={setIsFocusSales}
            isFocusItem={isFocusSales}
            rowIndex={salesIndex}
            setRowIndex={setSalesIndex}
            deleteEntriesModal={deleteSalesEntriesModal}
            setDeleteEntriesModal={setDeleteSalesEntriesModal}
            entryIndex={salesEntryIndex}
            setEntryIndex={setSalesEntryIndex}
            todayDate={todayDate}
            setRegistrationType={setRegistrationType}
            setAmtExcGst={setAmtSalesExcGst}
            setAmtIncGst={setAmtSalesIncGst}
            amountExcGst={amountSalesExcGst}
            amountIncGst={amountSalesIncGst}
            setBackdropOpen={setBackdropOpen}
            GStRates={GStRates}
            CessTypes={CessTypes}
            DiscountType={DiscountType}
            effectiveToFlag={salesEffectiveToFlag}
            setEffectiveToFlag={setSalesEffectiveToFlag}
            taxableValue={taxableValue}
            editFlag={editSalesFlag}
            setEditFlag={setEditSalesFlag}
            isFocusRow={isFocusSalesRow}
            setIsFocusRow={setIsFocusSalesRow}
            isValid={isSalesValid}
            setIsValid={setSalesValid}
            PriceTypes={PriceTypes}
            isDuplicate={isSalesDuplicate}
            setIsDuplicate={setIsSalesDuplicate}
            isActive={isSalesActive}
            setIsActive={setIsSalesActive}
            invDate={invDate}
            itemUsed={itemUsed}
            activeFlag={data.salesInvoice}
            focusCell={salesFocusCell}
            setFocusCell={setSalesFocusCell}
            params={params || { view: viewState }}
            openAccordan={openSalesAccordan}
            setOpenAccordan={setOpenSalesAccordan}
            priceTypeArr={priceTypeArr.filter(p => p.tabletype === 1)}
            setPriceTypeArr={setPriceTypeArr}
            priceTypeID={priceTypeID}
            setPriceTypeID={setPriceTypeID}
            setUpdatedPrice={setUpdatedSalesPrice}
            newArr={newSalesObj}
            newActiveArr={newActiveSalesObj}
            emptyPriceType={checkSalesPriceType}
            setEmptyPriceType={setCheckSalesPriceType}
            nameObj={sellingPriceObj}
            setTableErrArr={setTableErrArr}
            sellingPriceRows={sellingPriceRows}
            purchasePriceRows={purchasePriceRows}
            purchasePriceObj={purchasePriceObj}
            sellingPriceObj={sellingPriceObj}
            setDeletedRows={setDeletedSalesRows}
          />
        </Box>

        <Box
          // className={
          //   data?.purchaseAccount?.value === "" || params?.view === true
          //     ? "disable-interactions !important"
          //     : "none !important"
          // }
          className="custom-scrollbar"
          // sx={{
          //   borderRadius: '8px',
          //   // backgroundColor: "background.paper",
          //   // marginBottom: "10px",
          //   // mt:3,
          //   // boxShadow:
          //   //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          //   // padding: { xs: "10px 0px", sm: "10px 10px" },
          //   ':hover': {
          //     boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
          //   },
          //   transition: 'all 1s ease-in-out',
          //   pointerEvents: data.itemName === '' || data?.showItem?.length === 0 ? 'none' : '',
          // }}
            sx={{responsiveBoxSx}} //LEDX-5531
        >
          <NewSellingPriceTable
            key={itemBasicKey}
            Type={selectValue}
            tableType="Purchase"
            rows={purchasePriceRows}
            tempRow={tempPurchasePriceRows}
            editedRow={editedPurchasePriceRows}
            setRows={setPurchasePriceRows}
            setEditedRow={setEditedPurchasePriceRows}
            setTempRow={setTempPurchasePriceRows}
            data={data}
            endDate={endDate}
            startDate={startDate}
            setNewItemRowStatus={setPurchaseNewFlag}
            newItemRowStatus={purchaseNewFlag}
            setIsFocusItem={setIsFocusPurchase}
            isFocusItem={isFocusPurchase}
            rowIndex={purchaseIndex}
            setRowIndex={setPurchaseIndex}
            deleteEntriesModal={deletePurchaseEntriesModal}
            setDeleteEntriesModal={setDeletePurchaseEntriesModal}
            entryIndex={purchaseEntryIndex}
            setEntryIndex={setPurchaseEntryIndex}
            todayDate={todayDate}
            registrationType={registrationType}
            setRegistrationType={setRegistrationType}
            setAmtExcGst={setAmtPurchaseExcGst}
            setAmtIncGst={setAmtPurchaseIncGst}
            amountExcGst={amountPurchaseExcGst}
            amountIncGst={amountPurchaseIncGst}
            setBackdropOpen={setBackdropOpen}
            companyData={companyData}
            GStRates={GStRates}
            CessTypes={CessTypes}
            DiscountType={DiscountType}
            effectiveToFlag={purchaseEffectiveToFlag}
            setEffectiveToFlag={setPurchaseEffectiveToFlag}
            taxableValue={taxableValue}
            editFlag={editPurchaseFlag}
            setEditFlag={setEditPurchaseFlag}
            isFocusRow={isFocusPurchaseRow}
            setIsFocusRow={setIsFocusPurchaseRow}
            isValid={isPurchaseValid}
            setIsValid={setPurchaseValid}
            PriceTypes={PriceTypes}
            isDuplicate={isPurchaseDuplicate}
            setIsDuplicate={setIsPurchaseDuplicate}
            isActive={isPurchaseActive}
            setIsActive={setIsPurchaseActive}
            invDate={invDate}
            itemUsed={itemUsed}
            activeFlag={data.purchaseInvoice}
            focusCell={purchaseFocusCell}
            setFocusCell={setPurchaseFocusCell}
            params={params || { view: viewState }}
            openAccordan={openPurchaseAccordan}
            setOpenAccordan={setOpenPurchaseAccordan}
            priceTypeArr={priceTypeArr.filter(p => p.tabletype === 2)}
            setPriceTypeArr={setPriceTypeArr}
            priceTypeID={priceTypeID}
            setPriceTypeID={setPriceTypeID}
            setUpdatedPrice={setUpdatedPurchasePrice}
            newArr={newPurchaseObj}
            newActiveArr={newActivePurchaseObj}
            emptyPriceType={checkPurchasePriceType}
            setEmptyPriceType={setCheckPurchasePriceType}
            nameObj={purchasePriceObj}
            setTableErrArr={setTableErrArr}
            sellingPriceRows={sellingPriceRows}
            purchasePriceRows={purchasePriceRows}
            purchasePriceObj={purchasePriceObj}
            sellingPriceObj={sellingPriceObj}
            setDeletedRows={setDeletedPurchaseRows}
          />
        </Box>

        <Box
          sx={{
            borderRadius: '8px',
            // marginBottom: "10px",
            mt: 3,
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // padding: { xs: "10px 0px", sm: "10px 10px" },
            borderRadius: '8px',
            ':hover': {
              boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            },
            transition: 'all 1s ease-in-out',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} lg={3}>
              <ItemDescription
                data={data}
                setData={setData}
                params={params || { view: viewState }}
                arr={data?.purchaseAccount?.value !== '' ? purchasePriceRows : sellingPriceRows}
                nameObj={data?.purchaseAccount?.value !== '' ? purchasePriceObj : sellingPriceObj}
              />
            </Grid>
            <Grid item xs={12} lg={9}>
              <ItemAttachment
                view={viewPage}
                attachments={attachments}
                setAttachments={setAttachments}
                setDocuments={setCurrentDocuments}
                setInitialAttachments={setInitialAttachments}
                itemData={itemData}
                data={data}
                path={path}
                params={params || { view: viewState }}
              />
            </Grid>
          </Grid>
        </Box>
        <Box>
          <DraggableAction
            actionType={(itemID || params?.id) && params?.view !== true && viewState !== true ? 'edit' : 'save'}
            onSave={
              // (itemID || params?.id) &&
              params?.view === true || viewState === true
                ? undefined
                : itemID || params?.id
                ? async () => {
                    await saveEditChanges({ new: false }, 1, false);
                  }
                : async () => {
                    await saveChanges({ new: false });
                  }
            }
            onEnableEdit={() => {
              if (data?.is_active == 0) {
                return saveEditChanges({ new: false }, 1, true, 'cancel');
              }
              if (modalEvent == true) {
                params = { view: false };
                return setViewState(false);
              }
              navigate('/edititem', {
                state: { id: params?.id, view: false, type: params?.type },
              });
            }}
            onExit={() => {
              if (modalEvent) {
                if (closeModal) {
                  closeModal(false);
                }
              } else {
                navigate('/newItemList');
              }
            }}
            type={itemType}
            id={itemID || params?.id}
            onReset={
              (itemID || params?.id !== '' || params?.id !== undefined) && params?.view !== true
                ? () => {
                    if (itemID || (params?.id !== '' && params?.id !== undefined)) {
                      // getItemData(itemID || params?.id);

                      // setAttachments([])
                      setData(initialState);
                      if (currentSalesRows.length > 0) {
                        setSellingPriceRows(currentSalesRows);
                      } else {
                        setSellingPriceRows([newActiveSalesObj]);
                      }
                      if (currentPurchaseRows.length > 0) {
                        setPurchasePriceRows(currentPurchaseRows);
                      } else {
                        setPurchasePriceRows([newActivePurchaseObj]);
                      }
                      setAttachments(initialAttachments);
                    } else {
                      setCategoryId(mainCategoryId);
                      setAttachments([]);
                      // let obj = [
                      //   {
                      //     id: 0,
                      //     expiredtimestamp: 0,
                      //     amount: 0,
                      //     DiscountType: 1,
                      //     DiscountValue: 0,
                      //     gstRate: { rate: " ", id: "" },
                      //     cesstype: 1,
                      //     cess: 0,
                      //     amtaftdicount: 0,
                      //     discountAmt: 0,
                      //     priceType: { label: "", value: 0},
                      //     isActive: 1,
                      //     effectivefrom: "",
                      //     effectiveto: "",
                      //     amountIncludingGst: 0,
                      //     timeStamp: false,
                      //     editable: true,
                      //     new: true,
                      //     order: 1,
                      //     activeType: 1,
                      //     invoiceType: 1,
                      //   },
                      // ];
                      setSellingPriceRows([newActiveSalesObj]);
                      setPurchasePriceRows([newActivePurchaseObj]);
                      setData(initialState);
                    }
                    // reset();
                  }
                : null
            }
            onSaveNew={
              modalEvent === true || params?.view === true
                ? undefined
                : (itemID || params?.id) && params?.view !== true
                ? () => {
                    return saveEditChanges({ new: false }, 1, false);
                  }
                : () => {
                    saveChanges({ new: true });
                  }
            }
            loading={data.itemName === ''}
            // from={data?.is_active == 0 ? "active" : "inactive"}
            onCancel={
              (itemID || (params?.id !== '' && params?.id !== undefined)) && !modalEvent
                ? () => {
                    saveEditChanges({ new: false }, data?.is_active == 0 ? 1 : 0, false, 'cancel');
                  }
                : null
            }
            stat={data && data?.is_active == 1 ? 'inactive' : 'active'}
          />
        </Box>
        {/* ) : null} */}
        {console.log(modalEvent, 'modalEvent')}
        <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="newItemList" />

        <Loader open={backdropOpen}></Loader>
      </Box>
    </Box>
  );
}

export default AddNewItem;
